/* eslint-disable no-nested-ternary */
// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import Dropzone from "react-dropzone";
import JSZip from "jszip";

import Loader from "../../../commons/loader/loader";
import ZoomTable from "../../../commons/zoomTable/zoomTable";

import {
  pageObj,
  editOptions,
  toastrMessages,
  ticketStatusOptions,
  ticketPriorityOptions,
  radioOptions,
  analyticsEventList,
  renderOptions,
  goToViewTicket,
  goToCreateTicket
} from "./viewTicketHelper";
import styles from "./viewTicket.scss";
import { setPageName } from "../../../../services/pageService/pageActionCreator";
import RichTextInput from "../../../commons/formElements/richTextInput/richTextInput";
import BasicSelect from "../../../commons/formElements/basicSelect/basicSelect";
import TicketingSuggestionModal from "../../../commons/ticketingSuggestionModal/ticketingSuggestionModal";
import {
  getTicketDetails,
  sendCommentsDetails,
  getCommentDetails,
  getAssignToOptions,
  putEditTicketChanges,
  putTicketEscalateEmail,
  checkValidity,
  performTicketAction
} from "./viewTicketRedux/viewTicketActionCreator";

import {
  getFormattedDateAndTime,
  sendGaEvent,
  attachmentFileSizeInMB
} from "../../../../services/helpers";

import { getCcDetails } from "../createTicket/createTicketRedux/createTicketActionCreator";

import {
  getSLACellObject,
  isAuthorized,
  goToCnOrPrq,
  getSeverityOptions,
  severityOptions
} from "../../../containers/ticketing/ticketDashboard/ticketDashboardHelper";

import InputField from "../../../commons/formElements/inputField/inputField";
import Modal from "../../../commons/modal/modal";
import TicketingCcModal from "../../../commons/ticketingCcModal/ticketingCcModal";

const commentImageUrl = require("../../../../assets/images/ticketing_employee.svg");
const commentAttachmentUrl = require("../../../../assets/images/attachment_comment.svg");
const cancelAttachmentUrl = require("../../../../assets/images/cancel.svg");
const downloadAttachmentUrl = require("../../../../assets/images/download-symbol.svg");
const commentSystemImageUrl = require("../../../../assets/images/system_comment.svg");
const commentClientImageUrl = require("../../../../assets/images/client_comment.svg");
const fileUploadImage = require("../../../../assets/images/file_upload.svg");

type Props = {
  viewTicketState: Object,
  setPageName: Function,
  userProfile: Object,
  getTicketDetails: Function,
  sendCommentsDetails: Function,
  getCommentDetails: Function,
  getAssignToOptions: Function,
  checkValidity: Function,
  params: Object,
  history: Object,
  putEditTicketChanges: Function,
  putTicketEscalateEmail: Function,
  createTicketState: Object,
  getCcDetails: Function,
  performTicketAction: Function
};

type State = {
  typeOptions: Array<any>,
  sourceOptions: Array<any>,
  ticketStates: Array<any>,
  editOptions: Array<any>,
  storedComments: String,
  showAssignToOptions: Boolean,
  confirmModalTitle: String,
  showEditTicketModal: boolean,
  uploadFilesSelected: Array<any>,
  ccComment: String,
  showEscalateModal: boolean,
  escalateRecipients: Array<any>,
  escalateReason: String,
  escalateSubject: String,
  showAttachmentModal: boolean,
  uploadFilesSelected: Array<any>,
  displayClientCommunication: boolean,
  zipFileToBeSent: Object,
  reasonForClosure: String,
  showReasonForClosureModal: boolean,
  showViewChildTicketModal: boolean,
  showPriorityOptions: boolean,
  commentReset: boolean,
  ticketStatusSelected: String,
  ticketPrioritySelected: String,
  ticketAssigneeSelected: String,
  nextStatusOption: Array<any>,
  assigneeOptions: Array<any>,
  interactionCount: number,
  authorization: boolean,
  viewRenderMetadata: Object
};

class ViewTicket extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);

    this.alertMessage = "Nothing to show at the moment";
    this.state = {
      storedComments: "",
      showAssignToOptions: false,
      ccComment: "",
      showEscalateModal: false,
      escalateRecipients: null,
      escalateReason: "",
      showAttachmentModal: false,
      uploadFilesSelected: [],
      displayClientCommunication: false,
      zipFileToBeSent: null,
      reasonForClosure: "",
      showReasonForClosureModal: false,
      commentReset: false,
      ticketStatusSelected: "",
      ticketPrioritySelected: "",
      ticketAssigneeSelected: "",
      nextStatusOption: [],
      assigneeOptions: [],
      authorization: false,
      showViewChildTicketModal: false,
      viewRenderMetadata: [],
      showCCModal: false,
      ccList: [],
      showSuggestionModal: false
    };
    this.assigneeSearchTimeout = null;
  }

  componentWillMount() {
    this.props.setPageName(pageObj);
  }

  componentDidMount() {
    this.props.getTicketDetails(this.props.params.id);
    this.sendGaEventObject("render");
  }

  componentWillReceiveProps(nextProps) {
    const {
      ticketDetails,
      assignToOptionsDetails,
      ticketAction
    } = nextProps.viewTicketState;
    const { ccEmailDetails } = nextProps.createTicketState;
    if (
      ticketAction.performingTicketAction === false &&
      ticketAction.performedTicketAction === true &&
      !ticketAction.error
    ) {
      toastr.removeByType("light");
      toastr.removeByType("error");
      toastr.success("Success", "Ticket updated");
      window.location.reload();
    }
    if (
      ticketAction.performingTicketAction === false &&
      ticketAction.performedTicketAction === true &&
      typeof ticketAction.error === "string"
    ) {
      toastr.removeByType("success");
      toastr.removeByType("light");
      toastr.error("Error", ticketAction.error || "Failed to perform action");
    }
    if (
      ticketAction.performingTicketAction === true &&
      !ticketAction.performedTicketAction
    ) {
      toastr.removeByType("success");
      toastr.removeByType("error");
      toastr.light("Please wait", "Updating ticket");
    }
    if (
      ticketDetails.isLoaded &&
      ticketDetails.data !== this.props.viewTicketState.ticketDetails.data
    ) {
      this.setState({
        interactionCount: ticketDetails.data.interactionCount,
        ticketPrioritySelected: ticketDetails.data.priority,
        ticketStatusSelected: ticketDetails.data.status,
        ticketAssigneeSelected: ticketDetails.data.assigneeName,
        nextStatusOption: this.returnNextStatusOption(
          ticketDetails.data.nextPossibleStatus
        ),
        authorization: isAuthorized(this.props.userProfile, [
          "ROLE_EDIT_TICKET_CE",
          "ROLE_MANAGE_CATEGORY"
        ]),
        viewRenderMetadata:
          ticketDetails.data.ticketTypeDTO &&
          ticketDetails.data.ticketTypeDTO.viewRenderMetadata
            ? ticketDetails.data.ticketTypeDTO.viewRenderMetadata
            : [],
        ccList: ticketDetails.data.ccTicketDTOS
      });

      // This call is independent of the above setState function but needs to be called whenever ticketDetails is updated
      this.props.getCommentDetails(this.props.params.id);
    }
    if (
      assignToOptionsDetails.data !==
        this.props.viewTicketState.assignToOptionsDetails.data &&
      (assignToOptionsDetails.data.groupList ||
        assignToOptionsDetails.data.userList)
    ) {
      const options = [];
      if (assignToOptionsDetails.data.userList) {
        assignToOptionsDetails.data.userList.forEach(user =>
          options.push({
            key: user.name ? `${user.name} ${user.email}` : user.email,
            val: user.name ? user.name : user.email,
            id: user.id,
            type: "USER"
          })
        );
      }
      if (assignToOptionsDetails.data.groupList) {
        assignToOptionsDetails.data.groupList.forEach(group =>
          options.push({
            key: group.name,
            val: group.name,
            id: group.id,
            type: "GROUP"
          })
        );
      }
      this.setState({
        assigneeOptions: options
      });
    }
    if (
      ccEmailDetails.isLoaded &&
      !this.props.createTicketState.ccEmailDetails.isLoaded
    ) {
      this.updateCcList(ccEmailDetails);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.viewTicketState.commentDetails.data !==
      this.props.viewTicketState.commentDetails.data
    ) {
      this.scrollToBottom();
    }
  }

  onAttachmentDone() {
    this.attachmentModalDisplay(false);
    this.createZipFileToSend();
  }

  onChangeAssignToInput(val: String) {
    this.setState(
      {
        showAssignToOptions: true
      },
      () => {
        if (val && val !== "") {
          if (this.assigneeSearchTimeout != null) {
            clearTimeout(this.assigneeSearchTimeout);
          }
          this.assigneeSearchTimeout = setTimeout(
            this.props.getAssignToOptions.bind(this, val),
            500
          );
        }
      }
    );
  }

  onSendButtonPress() {
    if (this.state.storedComments === "" && !this.state.zipFileToBeSent) {
      const toastrOptions = {
        timeOut: 5000,
        component: <div>Either put a comment or attach a file to submit</div>
      };

      toastr.info("", toastrOptions);
    } else {
      const formdata = new FormData();

      formdata.append("ticketId", this.props.params.id);
      formdata.append("text", this.state.storedComments);
      formdata.append("file", this.state.zipFileToBeSent);

      if (this.state.displayClientCommunication) {
        // This data is to be sent only when CC is selected
        formdata.append("recipients", this.updateCC(this.state.ccComment));
        formdata.append(
          "subject",
          `Ticket: ${this.props.viewTicketState.ticketDetails.data.id} | ${this.props.viewTicketState.ticketDetails.data.title}`
        );
        formdata.append("body", this.state.storedComments);

        // Send GA event
        this.sendGaEventObject("clientCommunication");
      } else {
        formdata.append("recipients", "");
        formdata.append("subject", "");
        formdata.append("body", "");
      }
      this.props.sendCommentsDetails(
        formdata,
        this.props.getCommentDetails,
        this.props.params.id,
        this.props.viewTicketState.ticketDetails.data &&
          this.props.viewTicketState.ticketDetails.data.actualFirstResponse,
        this.props.getTicketDetails
      );

      this.setState({
        storedComments: "",
        commentReset: !this.state.commentReset,
        uploadFilesSelected: [],
        ccComment: "",
        zipFileToBeSent: null
      });
    }
  }

  onReasonForClosureDone() {
    if (this.state.reasonForClosure !== "") {
      this.setState({
        showReasonForClosureModal: false
      });
      this.sendEditTicketChange(
        { id: "CLOSED", val: "CLOSED" },
        editOptions.STATUS
      );
    } else {
      const toastrForNoReason = {
        timeOut: 5000,
        component: (
          <div>
            <h2>Error!</h2>
            <h3>Please type a reason for ticket closure</h3>
          </div>
        )
      };
      toastr.error("", toastrForNoReason);
    }
  }

  onRemoveAttachmentFile(file) {
    const removeIndex = this.state.uploadFilesSelected
      .map(f => f.name)
      .indexOf(file.name);
    const remainingFiles = this.state.uploadFilesSelected;
    remainingFiles.splice(removeIndex, 1);
    this.setState({
      uploadFilesSelected: remainingFiles
    });
  }

  onRadioOptionChange(val: boolean) {
    this.setState({
      displayClientCommunication: val
    });
  }

  onEntityIdClick() {
    const { ticketDetails } = this.props.viewTicketState;
    goToCnOrPrq({
      entityId: ticketDetails.data.entityId,
      entityType: ticketDetails.data.ticketTypeDTO.entityType
    });
  }

  onTicketPrioritySelect(value) {
    this.setState(
      {
        ticketPrioritySelected: value
      },
      () => this.showToastr({ id: value, val: value }, editOptions.PRIORITY)
    );
  }

  onTicketSeveritySelect(value) {
    this.showToastr({ id: value, val: value }, editOptions.SEVERITY);
  }

  onTicketStatusSelect(value) {
    if (value === ticketStatusOptions.CLOSED) {
      this.setState({
        ticketStatusSelected: value,
        showReasonForClosureModal: true
      });
    } else {
      this.setState(
        {
          ticketStatusSelected: value
        },
        () => this.showToastr({ id: value, val: value }, editOptions.STATUS)
      );
    }
  }

  onTicketAssigneeSelect(val, event) {
    this.setState(
      {
        ticketAssigneeSelected: val
      },
      () => this.showToastr(event, editOptions.ASSIGNEE)
    );
  }

  onAssignToMeClick() {
    this.showToastr(
      {
        id: this.props.userProfile.user_id,
        val: `${this.props.userProfile.first_name} ${this.props.userProfile.last_name}`
      },
      editOptions.ASSIGN_TO_ME
    );
  }

  onActionButtonClick(val, metaData) {
    let msg = `Are you sure you want to ${val.buttonText} the changes?`;
    if (val.popupText) {
      msg += ` ${val.popupText}`;
    }
    const toastrOptions = {
      okText: "Confirm",
      title: "Warning",
      cancelText: "Cancel",
      transitionIn: "fadeIn",
      transitionOut: "fadeOut",
      onOk: () => {
        this.props.performTicketAction({
          ticketId: this.props.params.id,
          actionName: metaData.key,
          actionValue: val.buttonText
        });
      },
      onCancel: () => {}
    };
    toastr.removeByType("success");
    toastr.removeByType("error");
    toastr.confirm(msg, toastrOptions);
  }

  sendGaEventObject(label) {
    sendGaEvent(
      analyticsEventList[label],
      "zoom-panel-ticketing-view-ticket",
      this.props.userProfile
    );
  }

  returnNextStatusOption(value: String) {
    if (value === ticketStatusOptions.IN_PROGRESS) {
      return [
        {
          key: "IN PROGRESS",
          val: value
        }
      ];
    }
    return [
      {
        key: value,
        val: value
      }
    ];
  }

  returnCurrentStatusOption(value: String) {
    if (value === ticketStatusOptions.IN_PROGRESS) {
      return "IN PROGRESS";
    }
    return value;
  }

  addToCCList(val) {
    this.props.getCcDetails(val);
  }

  deleteFromCCList(i) {
    const { ccList } = this.state;
    ccList.splice(i, 1);
    this.setState({
      ccList
    });
    this.sendEditTicketChange({ ccList }, editOptions.CHANGE_CC);
  }

  displayFileSize(size: number) {
    if (size <= 1024) {
      return `${size} bytes`;
    } else if (size > 1024 && size < 1000000) {
      return `${parseFloat(Math.round(size / 1024)).toFixed(2)} KB`;
    }

    return `${parseFloat(Math.round(size / 1000000)).toFixed(2)} MB`;
  }

  isTicketClosed() {
    if (
      this.props.viewTicketState.ticketDetails &&
      this.props.viewTicketState.ticketDetails.data &&
      this.props.viewTicketState.ticketDetails.data.status ===
        ticketStatusOptions.CLOSED
    ) {
      return true;
    }
    return false;
  }

  resetDefaultSettings() {
    this.setState({
      showAssignToOptions: false,
      ticketPrioritySelected: this.props.viewTicketState.ticketDetails.data
        .priority,
      ticketAssigneeSelected: this.props.viewTicketState.ticketDetails.data
        .assigneeName,
      ticketStatusSelected: this.props.viewTicketState.ticketDetails.data.status
    });
  }

  showToastr(event, type: String) {
    if (event) {
      const toastrConfirmOptions = {
        okText: "Confirm",
        title: "Confirmation",
        cancelText: "Cancel",
        transitionIn: "bounceIn",
        transitionOut: "bounceOut",
        onOk: () => {
          this.sendEditTicketChange(event, type);
        },
        onCancel: () => {
          this.resetDefaultSettings();
        }
      };

      if (type === editOptions.ASSIGNEE || type === editOptions.ASSIGN_TO_ME) {
        toastr.confirm(
          <div className={styles.toastrMainText}>
            {toastrMessages.ASSIGNEE}
          </div>,
          toastrConfirmOptions
        );
      } else if (type === editOptions.PRIORITY) {
        toastr.confirm(
          <div className={styles.toastrMainText}>
            {toastrMessages.PRIORITY}
          </div>,
          toastrConfirmOptions
        );
      } else if (type === editOptions.STATUS) {
        toastr.confirm(
          <div className={styles.toastrMainText}>{toastrMessages.STATUS}</div>,
          toastrConfirmOptions
        );
      } else if (type === editOptions.SEVERITY) {
        toastr.confirm(
          <div className={styles.toastrMainText}>
            {toastrMessages.SEVERITY}
          </div>,
          toastrConfirmOptions
        );
      } else {
        toastr.confirm(
          <div className={styles.toastrMainText}>
            {toastrMessages.INTERACTION_COUNT}
          </div>,
          toastrConfirmOptions
        );
      }
    }
  }

  saverecipients(val: String) {
    const recipientsArray = val.split(",");
    this.setState({
      escalateRecipients: recipientsArray
    });
  }

  closeAttachmentModal() {
    this.setState({
      showAttachmentModal: false,
      uploadFilesSelected: [],
      zipFileToBeSent: null
    });
  }

  checkRivigoEmailValidity(emails: Object) {
    let correctRecipients = true;
    emails.forEach(value => {
      if (
        !value.includes("@rivigo.com") &&
        !value.includes("@partners.rivigo.com") &&
        !value.includes("@mahindralogistics.com")
      ) {
        correctRecipients = false;
      }
    });
    return correctRecipients;
  }

  sendEscalationEmail() {
    if (this.state.escalateReason === "" || !this.state.escalateRecipients) {
      const toastrForNoInput = {
        timeOut: 5000,
        component: (
          <div>
            <h2>Error!</h2>
            <h3>Please fill the receipients and reason for closure</h3>
          </div>
        )
      };

      toastr.error("", toastrForNoInput);
    } else if (!this.checkRivigoEmailValidity(this.state.escalateRecipients)) {
      const toastrForWrongrecipients = {
        timeOut: 5000,
        component: (
          <div>
            <h2>Error!</h2>
            <h3>Please fill the recipients of rivigo only</h3>
          </div>
        )
      };

      toastr.error("", toastrForWrongrecipients);
    } else {
      this.setState({
        showEscalateModal: false
      });

      const escalateTicketDTO = {
        id: this.props.params.id,
        status: "ESCALATED",
        email: {
          recipient: this.state.escalateRecipients,
          body: this.state.escalateReason,
          subject: `Escalation | Ticket Id: ${
            this.props.viewTicketState.ticketDetails.data &&
            this.props.viewTicketState.ticketDetails.data.id
              ? this.props.viewTicketState.ticketDetails.data.id
              : ""
          }`
        }
      };

      this.props.putTicketEscalateEmail(escalateTicketDTO);
    }
  }

  updateCC(recipients: String) {
    let recipientsArray = [
      this.props.viewTicketState.ticketDetails.data.requestor.email
    ];
    if (recipients && recipients !== "") {
      recipientsArray = recipientsArray.concat(
        recipients.toString().split(",")
      );
    }
    return recipientsArray;
  }

  updateCcList(ccEmailDetails) {
    if (ccEmailDetails.data) {
      const { ccList } = this.state;
      ccList.push({
        userEmail: ccEmailDetails.data.email,
        ticketId: this.props.params.id
      });
      this.setState({
        ccList
      });
      this.sendEditTicketChange({ ccList }, editOptions.CHANGE_CC);
    } else {
      toastr.error("User not found!");
    }
  }

  showPriorityOptions() {
    if (
      this.props.viewTicketState.ticketDetails &&
      this.props.viewTicketState.ticketDetails.data &&
      this.props.viewTicketState.ticketDetails.data.priority ===
        ticketPriorityOptions.LOW
    ) {
      return [
        { key: ticketPriorityOptions.MEDIUM, val: ticketPriorityOptions.MEDIUM }
      ];
    } else if (
      this.props.viewTicketState.ticketDetails &&
      this.props.viewTicketState.ticketDetails.data &&
      this.props.viewTicketState.ticketDetails.data.priority ===
        ticketPriorityOptions.MEDIUM
    ) {
      return [
        { key: ticketPriorityOptions.HIGH, val: ticketPriorityOptions.HIGH }
      ];
    }
    return [];
  }

  scrollToBottom() {
    const objDiv = document.getElementById("commentScrollable");
    objDiv.scrollTop = objDiv.scrollHeight;
  }

  fileRejectionToastr() {
    const toastrOptions = {
      timeOut: 4000,
      component: (
        <div>
          <h2>Caution!</h2>
          <h3>
            {`  File of size above ${attachmentFileSizeInMB}MB is not accepted. Please select files of smaller size.`}
          </h3>
        </div>
      )
    };

    toastr.error("", toastrOptions);
  }

  closeEscalateModal() {
    this.setState({
      showEscalateModal: false,
      escalateRecipients: "",
      escalateReason: ""
    });
  }

  closeReasonForClosureModal() {
    this.setState({
      reasonForClosure: "",
      showReasonForClosureModal: false
    });
    this.resetDefaultSettings();
  }

  closeCCModal() {
    this.setState({
      showCCModal: false
    });
  }

  increaseInteractionCount() {
    this.setState({
      interactionCount:
        this.props.viewTicketState.ticketDetails.data.interactionCount + 1
    });
    this.sendEditTicketChange();
  }

  sendEditTicketChange(event, type: String) {
    const editTicketDTO = {
      id: this.props.params.id,
      assigneeType:
        type === editOptions.ASSIGNEE
          ? event.type
          : this.props.viewTicketState.ticketDetails.data.assigneeType,
      assigneeId:
        type === editOptions.ASSIGNEE || type === editOptions.ASSIGN_TO_ME
          ? event.id
          : this.props.viewTicketState.ticketDetails.data.assigneeId,
      priority:
        type === editOptions.PRIORITY
          ? event.id
          : this.props.viewTicketState.ticketDetails.data.priority,
      status:
        type === editOptions.STATUS
          ? event.id
          : this.props.viewTicketState.ticketDetails.data.status,
      interactionCount:
        type === editOptions.INTERACTION_COUNT
          ? this.state.interactionCount + 1
          : this.state.interactionCount,
      reasonOfClosure:
        type === editOptions.STATUS ? this.state.reasonForClosure : "",
      ccTicketDTOS:
        type === editOptions.CHANGE_CC
          ? event.ccList
          : this.props.viewTicketState.ticketDetails.data.ccTicketDTOS,
      severity:
        type === editOptions.SEVERITY
          ? event.id
          : this.props.viewTicketState.ticketDetails.data.severity
    };
    this.props.putEditTicketChanges(editTicketDTO, type);
    this.setState({
      showAssignToOptions: false,
      reasonForClosure: ""
    });
    this.sendGaEventObject("editTicketEvent");
  }

  updateFilesToUpload(files: Array) {
    this.setState({
      uploadFilesSelected: this.state.uploadFilesSelected.concat(files)
    });
  }

  updateStoredComments(comment: String) {
    this.setState({
      storedComments: comment
    });
  }

  createZipFileToSend() {
    const zipFile = new JSZip();
    this.state.uploadFilesSelected.map(fileIterator =>
      zipFile.file(fileIterator.name, fileIterator)
    );

    zipFile
      .generateAsync({ type: "blob" })
      .then(zipFileCreated => {
        const zipFileToSend = new File(
          [zipFileCreated],
          `${this.props.viewTicketState.ticketDetails.data.id}_${
            this.props.userProfile.user_id
          }_${Date.now()}.zip`
        );
        this.setState({
          zipFileToBeSent: zipFileToSend
        });
      })
      .catch(error => {
        //  eslint-disable-next-line
        console.log("Attachments zipfile create failed", error);
      });
  }

  displayRadioButtons() {
    return (
      <div className={`${styles.radioCombinedDiv} l-row flex-85`}>
        {this.state.viewRenderMetadata &&
        this.state.viewRenderMetadata.internalCommunication &&
        this.state.viewRenderMetadata.internalCommunication ===
          renderOptions.ENABLED ? (
          // eslint-disable-next-line react/jsx-indent
          <label htmlFor="1" className={`${styles.radioContainer} l-row`}>
            <input
              type="radio"
              name="radio"
              id="1"
              defaultChecked="checked"
              value={radioOptions.Internal_Note}
              onClick={() => {
                this.onRadioOptionChange(false);
              }}
            />
            {radioOptions.Internal_Note}
            <span className={styles.checkmark} />
          </label>
        ) : null}
        {this.state.viewRenderMetadata &&
        this.state.viewRenderMetadata.clientCommunication &&
        this.state.viewRenderMetadata.clientCommunication ===
          renderOptions.ENABLED ? (
          // eslint-disable-next-line react/jsx-indent
          <label htmlFor="2" className={`${styles.radioContainer} l-row`}>
            <input
              type="radio"
              name="radio"
              id="2"
              value={radioOptions.Client_Communication}
              onClick={() => {
                this.onRadioOptionChange(true);
              }}
            />
            {radioOptions.Client_Communication}
            <span className={styles.checkmark} />
          </label>
        ) : null}
      </div>
    );
  }

  downloadAttachment(url: String) {
    window.open(url, "_blank");
  }

  updateReasonForClosure(event) {
    this.setState({
      reasonForClosure: event.target.value
    });
  }

  updateEscalateReason(event) {
    this.setState({
      escalateReason: event.target.value
    });
  }

  escalateModalDisplay(show: boolean) {
    this.setState({
      showEscalateModal: show
    });
  }

  childTicketModalDisplay(show: boolean) {
    this.setState({
      showViewChildTicketModal: show
    });
  }

  attachmentModalDisplay(show: boolean) {
    this.setState({
      showAttachmentModal: show
    });
  }

  checkRequestorNameCondition() {
    return (
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.requestorEmail &&
      this.state.viewRenderMetadata.requestorEmail !== renderOptions.HIDDEN
    );
  }

  checkRequestorEmailCondition() {
    return (
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.requestorEmail &&
      this.state.viewRenderMetadata.requestorEmail !== renderOptions.HIDDEN
    );
  }

  checkRequestorMobileCondition() {
    return (
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.requestorMobile &&
      this.state.viewRenderMetadata.requestorMobile !== renderOptions.HIDDEN
    );
  }

  checkRequestorTitleCondition() {
    return (
      this.checkRequestorEmailCondition() ||
      this.checkRequestorMobileCondition() ||
      this.checkRequestorNameCondition()
    );
  }

  checkAssignToMeCondition(ticketDetails) {
    return (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.assignToMe &&
      this.state.viewRenderMetadata.assignToMe !== renderOptions.HIDDEN &&
      ticketDetails.data &&
      ticketDetails.data.assigneeName &&
      ticketDetails.data.assigneeName !== this.props.userProfile.first_name &&
      !this.isTicketClosed()
    );
  }

  checkSendButtonCondition() {
    return (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.sendButton &&
      this.state.viewRenderMetadata.sendButton === renderOptions.ENABLED
    );
  }

  checkTicketStatusCondition() {
    return (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.ticketStatus &&
      this.state.viewRenderMetadata.ticketStatus === renderOptions.ENABLED
    );
  }

  checkTicketAssigneeCondition() {
    return (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.ticketAssignee &&
      this.state.viewRenderMetadata.ticketAssignee === renderOptions.ENABLED &&
      !this.isTicketClosed()
    );
  }

  checkEscalateButtonCondition() {
    return (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.escalateButton &&
      this.state.viewRenderMetadata.escalateButton === renderOptions.ENABLED &&
      !this.isTicketClosed()
    );
  }

  checkViewChildTicketButtonDisplay() {
    return (
      (this.state.viewRenderMetadata &&
        this.state.viewRenderMetadata.viewChildButton &&
        this.state.viewRenderMetadata.viewChildButton ===
          renderOptions.ENABLED &&
        this.isTicketClosed()) ||
      (this.props.viewTicketState.ticketDetails.data &&
        !this.props.viewTicketState.ticketDetails.data.childTicketDTOList)
    );
  }

  checkChildTicketButtonDisplayCondition() {
    return (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.createChildButton &&
      this.state.viewRenderMetadata.createChildButton ===
        renderOptions.ENABLED &&
      !this.isTicketClosed() &&
      !(
        this.props.viewTicketState.ticketDetails.data &&
        this.props.viewTicketState.ticketDetails.data.parentId
      ) &&
      this.state.authorization
    );
  }

  returnUtilityStyle() {
    return this.isTicketClosed()
      ? styles.utilityBarTicketClosed
      : styles.utilityBarTicketOpen;
  }

  renderTicketTypeBasedActions(actions) {
    if (!actions || !actions.length) {
      return null;
    }
    const metadata = actions[0];
    return (
      <div className={`${styles.buttonContainer}`}>
        {metadata.value.map(vl => (
          <div
            key={vl.buttonText}
            className={`${styles.qcBtnWrapper} ${styles.noAbs}`}
            onClick={() => this.onActionButtonClick(vl, metadata)}
          >
            {vl.buttonText.toUpperCase()}
          </div>
        ))}
      </div>
    );
  }

  renderButtonsBasedOnTicketType() {
    if (!this.props.viewTicketState.ticketDetails) {
      return null;
    }
    if (!this.props.viewTicketState.ticketDetails.data) {
      return null;
    }
    if (
      this.props.viewTicketState.ticketDetails.data.status ===
      ticketStatusOptions.CLOSED
    ) {
      return null;
    }
    const { ticketTypeDTO } = this.props.viewTicketState.ticketDetails.data;
    if (ticketTypeDTO && ticketTypeDTO.actionRenderMetadata) {
      const { actions } = ticketTypeDTO.actionRenderMetadata;
      return this.renderTicketTypeBasedActions(actions);
    }
    return null;
  }

  renderFooter() {
    if (!this.isTicketClosed()) {
      return (
        <div className={`${styles.footer} l-row a-start flex-100`}>
          <div className="l-col a-start j-center flex-100">
            {this.displayRadioButtons()}
            {this.state.displayClientCommunication
              ? this.renderClientCommunication()
              : null}
            <div
              className={`${
                this.state.authorization
                  ? styles.writeComment
                  : styles.writeCommentNotCe
              } l-row a-end`}
            >
              <div className={`${styles.createComment} flex-80`}>
                <RichTextInput
                  onChange={val => {
                    this.updateStoredComments(val);
                  }}
                  resetText={this.state.commentReset}
                />
              </div>
              <div className="flex-5">
                <button
                  className={`${styles.attachmentButton} flex-5`}
                  onClick={() => {
                    this.attachmentModalDisplay(true);
                  }}
                >
                  <img
                    src={commentAttachmentUrl}
                    alt="Loading..."
                    className={styles.attachmentIcn}
                  />
                </button>
              </div>

              {this.renderSendButton()}
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  renderSendButton() {
    if (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.sendButton &&
      this.state.viewRenderMetadata.sendButton !== renderOptions.HIDDEN
    ) {
      return (
        <div className="flex-10">
          {this.checkSendButtonCondition() ? (
            <div
              className={`${styles.rectangleSendButton}`}
              onClick={() => this.onSendButtonPress()}
            >
              SEND
            </div>
          ) : (
            <div className={`${styles.disableRectangleSendButton} half-opac`}>
              SEND
            </div>
          )}
        </div>
      );
    }
    return null;
  }

  renderInteractionCount() {
    if (this.state.authorization && !this.isTicketClosed()) {
      if (
        this.state.viewRenderMetadata &&
        this.state.viewRenderMetadata.ticketInteractionCount &&
        this.state.viewRenderMetadata.ticketInteractionCount ===
          renderOptions.ENABLED
      ) {
        return (
          <div className={`${this.returnUtilityStyle()} l-row a-center`}>
            <div className={`${styles.textStyle} flex-40 l-row`}>
              Interaction Count
            </div>
            <div className="l-row flex-60">
              <div className={`${styles.textStyle} flex-70 l-row`}>
                <InputField
                  type="number"
                  disabled={true}
                  value={
                    this.state.interactionCount
                      ? this.state.interactionCount.toString()
                      : "0"
                  }
                  onChange={() => {
                    this.updateInteractionCount();
                  }}
                />
              </div>
              <div className={`${styles.textStyle} flex-30 l-row`}>
                <button
                  className={styles.interactionCountButton}
                  onClick={() =>
                    this.showToastr(
                      "interactionCount",
                      editOptions.INTERACTION_COUNT
                    )
                  }
                >
                  +
                </button>
              </div>
            </div>
          </div>
        );
      } else if (
        this.state.viewRenderMetadata &&
        this.state.viewRenderMetadata.ticketInteractionCount &&
        this.state.viewRenderMetadata.ticketInteractionCount ===
          renderOptions.DISABLED
      ) {
        return (
          <div className={`${this.returnUtilityStyle()} l-row a-center`}>
            <div className={`${styles.textStyle} flex-40 l-row`}>
              Interaction Count
            </div>
            <div className={`${styles.textStyle} flex-40 l-row`}>
              {this.state.interactionCount
                ? this.state.interactionCount.toString()
                : "0"}
            </div>
          </div>
        );
      }
    }
    return null;
  }

  renderAssignToMe(ticketDetails) {
    if (this.checkAssignToMeCondition(ticketDetails)) {
      return (
        <div className={`${styles.secondUtilityBar} j-end l-row a-center`}>
          <div
            className={`${styles.assignToMe} flex-60 l-row`}
            onClick={() => this.onAssignToMeClick()}
          >
            <u> Assign to Me</u>
          </div>
        </div>
      );
    }
    return null;
  }

  renderAssist(ticketDetails) {
    if (this.checkAssignToMeCondition(ticketDetails)) {
      return (
        <div className={`${styles.secondUtilityBar} j-end l-row a-center`}>
          <div
            className={`${styles.assignToMe} flex-20 l-row`}
            onClick={() => this.setState({ showSuggestionModal: true })}
          >
            <u> Assist</u>
          </div>
        </div>
      );
    }
    return null;
  }

  renderTicketPriority() {
    if (!this.isTicketClosed()) {
      if (
        this.state.viewRenderMetadata &&
        this.state.viewRenderMetadata.ticketPriority &&
        this.state.viewRenderMetadata.ticketPriority === renderOptions.ENABLED
      ) {
        return (
          <div className={`${this.returnUtilityStyle()} l-row a-center`}>
            <div className={`${styles.textStyle} flex-40 l-row`}>Priority</div>
            <div className={`${styles.textStyle} flex-60 l-row`}>
              <BasicSelect
                label="Select Priority"
                selectedOpt={this.state.ticketPrioritySelected}
                optionsArrOfObj={this.showPriorityOptions()}
                onSelect={value => {
                  this.onTicketPrioritySelect(value);
                }}
              />
            </div>
          </div>
        );
      } else if (
        this.state.viewRenderMetadata &&
        this.state.viewRenderMetadata.ticketPriority &&
        this.state.viewRenderMetadata.ticketPriority === renderOptions.DISABLED
      ) {
        return (
          <div className={`${this.returnUtilityStyle()} l-row a-center`}>
            <div className={`${styles.textStyle} flex-40 l-row`}>Priority</div>
            <div className={`${styles.textStyle} flex-60 l-row`}>
              {this.state.ticketPrioritySelected}
            </div>
          </div>
        );
      }
    }
    return null;
  }

  renderTicketSeverity(ticketDetails) {
    if (ticketDetails && ticketDetails.data) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Severity</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            <BasicSelect
              label="Select severity"
              selectedOpt={ticketDetails.data.severity}
              optionsArrOfObj={getSeverityOptions(
                ticketDetails.data.ticketTypeDTO,
                severityOptions
              )}
              onSelect={value => {
                this.onTicketSeveritySelect(value);
              }}
            />
          </div>
        </div>
      );
    }
    return null;
  }

  renderTicketStatus() {
    if (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.ticketStatus &&
      this.state.viewRenderMetadata.ticketStatus !== renderOptions.HIDDEN
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Status</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {this.checkTicketStatusCondition() ? (
              <BasicSelect
                label="Select Status"
                selectedOpt={this.returnCurrentStatusOption(
                  this.state.ticketStatusSelected
                )}
                optionsArrOfObj={this.state.nextStatusOption}
                onSelect={value => {
                  this.onTicketStatusSelect(value);
                }}
              />
            ) : (
              this.returnCurrentStatusOption(this.state.ticketStatusSelected)
            )}
          </div>
        </div>
      );
    }
    return null;
  }

  renderTicketAssignee() {
    if (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.ticketAssignee &&
      this.state.viewRenderMetadata.ticketAssignee !== renderOptions.HIDDEN
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Assignee</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {this.checkTicketAssigneeCondition() ? (
              <div className={styles.assigneeSelectWrapper}>
                <BasicSelect
                  label="Select Assignee"
                  selectedOpt={this.state.ticketAssigneeSelected}
                  optionsArrOfObj={this.state.assigneeOptions}
                  onSelect={(val, event) => {
                    this.onTicketAssigneeSelect(val, event);
                  }}
                  enableSearch={!this.isTicketClosed()}
                  passEvent={true}
                  disabled={this.isTicketClosed()}
                  onChangeInput={val => {
                    this.onChangeAssignToInput(val);
                  }}
                  showOptions={this.state.showAssignToOptions}
                />
                <TicketingSuggestionModal
                  showModal={this.state.showSuggestionModal}
                  title="Suggest assignee"
                  closeModal={() =>
                    this.setState({ showSuggestionModal: false })
                  }
                  assignTicket={assignee => {
                    this.setState({ showSuggestionModal: false }, () => {
                      this.onTicketAssigneeSelect(assignee.name, {
                        id: assignee.id,
                        type: assignee.type
                      });
                    });
                  }}
                />
              </div>
            ) : (
              this.state.ticketAssigneeSelected
            )}
          </div>
        </div>
      );
    }
    return null;
  }

  renderViewChildTicketModal() {
    return (
      <Modal
        showModal={this.state.showViewChildTicketModal}
        title="Child Ticket(s)"
        closeModal={() => this.childTicketModalDisplay(false)}
      >
        <div className={`${styles.reasonForClosureWrapper}`}>
          <ZoomTable
            configKey="VIEW_CHILD_TICKET_KEY"
            tableDataLength={
              this.props.viewTicketState.ticketDetails.data &&
              this.props.viewTicketState.ticketDetails.data
                .childTicketDTOList &&
              this.props.viewTicketState.ticketDetails.data.childTicketDTOList
                .length
                ? this.props.viewTicketState.ticketDetails.data
                    .childTicketDTOList.length
                : 0
            }
            tableData={
              this.props.viewTicketState.ticketDetails.data &&
              this.props.viewTicketState.ticketDetails.data.childTicketDTOList
                ? this.props.viewTicketState.ticketDetails.data
                    .childTicketDTOList
                : []
            }
          />
          <div className={`l-row flex-100 ${styles.attachmentConfirmBtn}`}>
            <div
              className={` ${styles.escalateModalBtnWrapper} l-row a-center j-center`}
              onClick={() => this.childTicketModalDisplay(false)}
            >
              Done
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderReasonForClosureModal() {
    return (
      <Modal
        showModal={this.state.showReasonForClosureModal}
        title="Reason for Closure"
        closeModal={() => this.closeReasonForClosureModal()}
      >
        <div className={`${styles.reasonForClosureWrapper}`}>
          <div className={`${styles.reasonForClosureText} j-center`}>
            <textarea
              aria-required="true"
              required={true}
              className={styles.escalateModalBodyWrapper}
              onChange={event => {
                this.updateReasonForClosure(event);
              }}
            />
          </div>
          <div className={`l-row flex-100 ${styles.attachmentConfirmBtn}`}>
            <div
              className={` ${styles.escalateModalBtnWrapper} l-row a-center j-center`}
              onClick={() => this.onReasonForClosureDone()}
            >
              Submit
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderCommentImage(id: number, userType: String) {
    if (id && id === 35) {
      return commentSystemImageUrl;
    } else if (userType && userType === "REQUESTOR") {
      return commentClientImageUrl;
    }
    return commentImageUrl;
  }

  renderComments(data: Array<any>) {
    return data.map((comment, index) => (
      <div
        key={index}
        className={
          index % 2 === 0
            ? `${styles.rectangleChatLeft} l-row`
            : `${styles.rectangleChatRight} l-row`
        }
      >
        <div className="l-col flex-7">
          <div>
            <img
              className={styles.commentIcn}
              src={this.renderCommentImage(
                comment.userDTO && comment.userDTO.id,
                comment.userType
              )}
              alt="Loading..."
            />
          </div>
        </div>
        <div className="l-col flex-90">
          <div className="l-row">
            <div className="l-row flex-80">
              {" "}
              {comment.userDTO &&
              comment.userDTO.id &&
              comment.userDTO.id === 35 ? (
                <div className="j-start">
                  <div className={`${styles.nameChat} flex-90`}>
                    auto-generated comment
                  </div>
                </div>
              ) : (
                <div className="j-start">
                  <div className={`${styles.nameChat} flex-50`}>
                    {comment.userDTO && comment.userDTO.name}
                  </div>
                  <div className={`${styles.emailChat} flex-50`}>
                    {comment.userDTO && comment.userDTO.email}
                  </div>
                </div>
              )}
            </div>
            <div className="j-end flex-20">
              <div className={`${styles.dateChat}`}>
                {getFormattedDateAndTime(comment.createdAt)}
              </div>
            </div>
          </div>

          <div className="l-row">
            <div
              className={`${styles.commentChat} flex-100 a-start`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: comment.text
                  ? comment.text.replace("IN_PROGRESS", "IN PROGRESS")
                  : ""
              }}
            />
            {comment.attachmentURL ? (
              <div className="flex-10 a-end j-end">
                <button
                  className={styles.downloadAttachmentButton}
                  onClick={() => {
                    this.downloadAttachment(comment.attachmentURL);
                  }}
                >
                  {" "}
                  <img
                    src={downloadAttachmentUrl}
                    alt="Loading..."
                    className={styles.downloadAttachmentIcn}
                  />
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    ));
  }

  renderEscalateButton() {
    if (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.escalateButton &&
      this.state.viewRenderMetadata.escalateButton !== renderOptions.HIDDEN
    ) {
      return (
        <div className="flex-45 l-row">
          {this.checkEscalateButtonCondition() ? (
            <div
              className={`${styles.btnWrapper}`}
              onClick={() => {
                this.escalateModalDisplay(true);
              }}
            >
              Escalate
            </div>
          ) : (
            <div className={`${styles.btnDisableWrapper}`}>Escalate</div>
          )}
        </div>
      );
    }
    return null;
  }

  renderViewChildTicketButton() {
    if (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.viewChildButton &&
      this.state.viewRenderMetadata.viewChildButton !== renderOptions.HIDDEN
    ) {
      return (
        <div className="flex-100 l-row a-center">
          {this.checkViewChildTicketButtonDisplay() ? (
            <div
              className={`${styles.btnDisableWrapper} flex-97 l-row j-center`}
            >
              View Child Ticket(s)
            </div>
          ) : (
            <div
              className={`${styles.btnWrapper} flex-97 l-row j-center`}
              onClick={() => {
                this.childTicketModalDisplay(true);
              }}
            >
              View Child Ticket(s)
            </div>
          )}
        </div>
      );
    }
    return null;
  }

  renderCreateChildTicketButton(ticketDetails) {
    if (
      this.state.viewRenderMetadata &&
      this.state.viewRenderMetadata.createChildButton &&
      this.state.viewRenderMetadata.createChildButton !== renderOptions.HIDDEN
    ) {
      return (
        <div className="flex-50s l-row">
          {this.checkChildTicketButtonDisplayCondition() ? (
            <div
              className={`${styles.btnWrapper} l-row`}
              onClick={() =>
                goToCreateTicket({
                  id: ticketDetails.data.id
                })
              }
            >
              <div className={`${styles.plusSymbolImage} flex-30`}>+ |</div>
              <div> Child Ticket</div>
            </div>
          ) : (
            <div className={`${styles.btnDisableWrapper}`}>
              + | Child Ticket
            </div>
          )}
        </div>
      );
    }
    return null;
  }

  renderEscalateModal() {
    return (
      <Modal
        showModal={this.state.showEscalateModal}
        title="Escalate Email"
        closeModal={() => this.closeEscalateModal()}
      >
        <div className={`${styles.escalateModalWrapper}`}>
          <div className={`${styles.escalateModalRow} l-row`}>
            <div className={`${styles.escalateModalText} flex-10`}>To</div>
            <div className={`${styles.escalateModalInputWrapper} flex-90`}>
              <InputField
                type="email"
                onChange={val => this.saverecipients(val)}
              />
            </div>
          </div>

          <div className={`${styles.escalateModalRow} l-row`}>
            <div className={`${styles.escalateModalText} flex-10`}>Sub</div>
            <div className={`${styles.escalateModalInputWrapper} flex-90`}>
              <InputField
                type="text"
                value={`Escalation | Ticket ID: ${
                  this.props.viewTicketState.ticketDetails.data &&
                  this.props.viewTicketState.ticketDetails.data.id
                    ? this.props.viewTicketState.ticketDetails.data.id
                    : ""
                }`}
                disabled={true}
                onChange={() => this.updateEscalateSubject()}
              />
            </div>
          </div>

          <div className={`${styles.escalateModalRow} l-row`}>
            <div className={`${styles.escalateModalText} flex-10`} />
            <div className="flex-90">
              <textarea
                aria-required="true"
                required={true}
                className={styles.escalateModalBodyWrapper}
                onChange={event => {
                  this.updateEscalateReason(event);
                }}
              />
            </div>
          </div>

          <div className={`${styles.escalateModalRow} l-row j-end flex-100`}>
            <div
              className={` ${styles.escalateModalBtnWrapper} l-row a-center j-center`}
              onClick={() => this.sendEscalationEmail()}
            >
              Escalate
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderAttachmentModal() {
    return (
      <Modal
        showModal={this.state.showAttachmentModal}
        title="Attachments"
        closeModal={() => this.closeAttachmentModal()}
      >
        <div className={`${styles.attachmentModalWrapper}`}>
          <div className="l-row j-center">
            <div className={`${styles.attachmentWrapper} flex-100`}>
              <Dropzone
                className={`${styles.dropzoneWrapper}`}
                onDrop={files => {
                  this.updateFilesToUpload(files);
                }}
                multiple={true}
                disablePreview={false}
                maxSize={attachmentFileSizeInMB * 1048576}
                onDropRejected={() => {
                  this.fileRejectionToastr();
                }}
              >
                <div className={`${styles.initialAttachmentText}`}>
                  Click or Drag & Drop
                </div>
              </Dropzone>
              <div className={styles.attachmentFilesCombined}>
                {" "}
                {this.state.uploadFilesSelected.map(f => (
                  <div
                    key={f.name}
                    className={`${styles.uploadFileWrapper} l-row flex-100`}
                  >
                    <div className="flex-8">
                      <img
                        src={fileUploadImage}
                        alt=""
                        className={styles.commentIcn}
                      />
                    </div>
                    <div className="flex-100">
                      <div className={styles.attachmentFileName}>{f.name}</div>
                      <div className={styles.attachmentFileSize}>
                        {this.displayFileSize(f.size)}
                      </div>
                    </div>
                    <div className="flex-5 a-end">
                      <button
                        key={f.name}
                        className={styles.cancelButton}
                        onClick={() => this.onRemoveAttachmentFile(f)}
                      >
                        <img
                          className={styles.cancelAttachmentIcn}
                          src={cancelAttachmentUrl}
                          alt="Loading..."
                        />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={`l-row flex-100 ${styles.attachmentConfirmBtn}`}>
            <div
              className={` ${styles.escalateModalBtnWrapper} l-row a-center j-center`}
              onClick={() => this.onAttachmentDone()}
            >
              Done
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderClientCommunication() {
    const { ticketDetails } = this.props.viewTicketState;
    return (
      <div className={`${styles.emailCc} l-row flex-80`}>
        <div className={`${styles.toDivStyle} l-row flex-50`}>
          <div className={`${styles.toStyle} l-row`}>TO:</div>
          <div className={`${styles.toEmail} l-row`}>
            {ticketDetails.data &&
            ticketDetails.data.requestor &&
            ticketDetails.data.requestor.email
              ? ticketDetails.data.requestor.email
              : ""}
          </div>
        </div>
        <div className={`${styles.ccDivStyle} l-row flex-50`}>
          <div className={`${styles.ccStyle} flex-10`}>CC:</div>
          <div className={`${styles.createCc} flex-90`}>
            <InputField
              type="email"
              value={this.state.ccComment}
              onChange={val => {
                this.setState({
                  ccComment: val
                });
              }}
              disabled={false}
            />
            Enter comma separated email
          </div>
        </div>
      </div>
    );
  }

  renderOwner(ticketDetails) {
    if (ticketDetails && ticketDetails.data) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Owner</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data.ownerName}
          </div>
        </div>
      );
    }
    return null;
  }
  renderSLA(ticketDetails) {
    if (
      this.state.viewRenderMetadata !== [] &&
      (this.state.viewRenderMetadata.ticketSla === renderOptions.DISABLED ||
        this.state.viewRenderMetadata.ticketSla === renderOptions.ENABLED)
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>
            SLA resolution
          </div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data &&
            ticketDetails.data.escalateAt &&
            !this.isTicketClosed()
              ? getSLACellObject(ticketDetails.data.escalateAt)
              : "-"}
          </div>
        </div>
      );
    }
    return null;
  }

  renderFirstResponseSLA(ticketDetails) {
    if (
      this.state.viewRenderMetadata !== [] &&
      (this.state.viewRenderMetadata.ticketSla === renderOptions.DISABLED ||
        this.state.viewRenderMetadata.ticketSla === renderOptions.ENABLED) &&
      ticketDetails.data &&
      !ticketDetails.data.actualFirstResponse
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>
            SLA First Response
          </div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data &&
            ticketDetails.data.firstResponseAt &&
            !this.isTicketClosed()
              ? getSLACellObject(ticketDetails.data.firstResponseAt)
              : "-"}
          </div>
        </div>
      );
    }
    return null;
  }

  renderCCedEmailId() {
    if (
      this.state.viewRenderMetadata !== [] &&
      (this.state.viewRenderMetadata.ticketSla === renderOptions.DISABLED ||
        this.state.viewRenderMetadata.ticketSla === renderOptions.ENABLED)
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <TicketingCcModal
            showLoader={false}
            showModal={this.state.showCCModal}
            title="View cc email"
            closeModal={() => {
              this.closeCCModal();
            }}
            ccList={this.state.ccList}
            addToCCList={val => {
              this.addToCCList(val);
            }}
            deleteFromCCList={i => {
              this.deleteFromCCList(i);
            }}
          />
          <div className={`${styles.textStyle} flex-40 l-row`}>
            CC ed email id
          </div>
          <div
            className={`${styles.textStyleUnderline} flex-60 l-row cursor-p`}
            onClick={() => {
              this.setState({
                showCCModal: true
              });
            }}
          >
            View
          </div>
        </div>
      );
    }
    return null;
  }

  renderParentTicketId(ticketDetails) {
    if (
      ticketDetails.data &&
      ticketDetails.data.parentId &&
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.parentId &&
      this.state.viewRenderMetadata.parentId === renderOptions.ENABLED
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>
            Parent Ticket ID
          </div>
          <div
            className={`${styles.textStyle} flex-60 l-row cn-highlight`}
            onClick={() => goToViewTicket({ id: ticketDetails.data.parentId })}
          >
            {ticketDetails.data && ticketDetails.data.parentId
              ? ticketDetails.data.parentId
              : ""}
          </div>
        </div>
      );
    } else if (
      ticketDetails.data &&
      ticketDetails.data.parentId &&
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.parentId === renderOptions.DISABLED
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>
            Parent Ticket ID
          </div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data && ticketDetails.data.parentId
              ? ticketDetails.data.parentId
              : ""}
          </div>
        </div>
      );
    }
    return null;
  }

  renderPRQorCN(ticketDetails) {
    if (
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.entityId &&
      this.state.viewRenderMetadata.entityId !== renderOptions.HIDDEN
    ) {
      return ticketDetails.data &&
        ticketDetails.data.ticketTypeDTO &&
        ticketDetails.data.ticketTypeDTO.entityType !== "NONE" ? (
        // eslint-disable-next-line react/jsx-indent
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>
            {ticketDetails.data.ticketTypeDTO.entityType}
          </div>
          {this.state.viewRenderMetadata !== [] &&
          this.state.viewRenderMetadata.entityId &&
          this.state.viewRenderMetadata.entityId === renderOptions.ENABLED ? (
            <div
              className={`${styles.cnClickable} flex-60 l-row cn-highlight`}
              onClick={() => {
                this.onEntityIdClick();
              }}
            >
              {ticketDetails.data.entityId ? ticketDetails.data.entityId : "-"}
            </div>
          ) : (
            <div className={`${styles.textStyle} flex-60 l-row`}>
              {ticketDetails.data.entityId ? ticketDetails.data.entityId : "-"}
            </div>
          )}
        </div>
      ) : null;
    }
    return null;
  }

  renderTicketId(ticketDetails) {
    if (
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.ticketId &&
      this.state.viewRenderMetadata.ticketId !== renderOptions.HIDDEN
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Ticket ID</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data && ticketDetails.data.id
              ? ticketDetails.data.id
              : ""}
          </div>
        </div>
      );
    }
    return null;
  }

  renderTicketType(ticketDetails) {
    if (
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.ticketType &&
      this.state.viewRenderMetadata.ticketType !== renderOptions.HIDDEN
    ) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Ticket Type</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data &&
            ticketDetails.data.ticketTypeDTO &&
            ticketDetails.data.ticketTypeDTO.name
              ? ticketDetails.data.ticketTypeDTO.name
              : ""}
          </div>
        </div>
      );
    }
    return null;
  }

  renderTicketComments(commentDetails) {
    return (
      <div
        id="commentScrollable"
        className={
          this.isTicketClosed()
            ? styles.commentScrollableTicketClosed
            : styles.commentScrollable
        }
      >
        {commentDetails.isLoading ? <Loader /> : null}
        {commentDetails.data ? this.renderComments(commentDetails.data) : ""}
      </div>
    );
  }

  renderRequestorMobile(ticketDetails) {
    if (this.checkRequestorMobileCondition()) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Mobile</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data &&
            ticketDetails.data.requestor &&
            ticketDetails.data.requestor.mobileNo
              ? ticketDetails.data.requestor.mobileNo
              : ""}
          </div>
        </div>
      );
    }
    return null;
  }

  renderRequestorEmail(ticketDetails) {
    if (this.checkRequestorEmailCondition()) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Email ID</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data &&
            ticketDetails.data.requestor &&
            ticketDetails.data.requestor.email
              ? ticketDetails.data.requestor.email
              : ""}
          </div>
        </div>
      );
    }
    return null;
  }

  renderRequestorName(ticketDetails) {
    if (this.checkRequestorNameCondition()) {
      return (
        <div className={`${this.returnUtilityStyle()} l-row a-center`}>
          <div className={`${styles.textStyle} flex-40 l-row`}>Name</div>
          <div className={`${styles.textStyle} flex-60 l-row`}>
            {ticketDetails.data &&
            ticketDetails.data.requestor &&
            ticketDetails.data.requestor.name
              ? ticketDetails.data.requestor.name
              : ""}
          </div>
        </div>
      );
    }
    return null;
  }

  renderTicketOwnerName(ticketDetails) {
    if (
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.requestorName &&
      this.state.viewRenderMetadata.requestorName !== renderOptions.HIDDEN
    ) {
      return (
        <div className={`${styles.ticketOwnerDetails}`}>
          {ticketDetails.data && ticketDetails.data.createdAt
            ? getFormattedDateAndTime(ticketDetails.data.createdAt)
            : ""}
          |{" "}
          {ticketDetails.data && ticketDetails.data.ownerName
            ? ticketDetails.data.ownerName
            : ""}
        </div>
      );
    }
    return null;
  }

  renderTicketTitle(ticketDetails) {
    const { validityDetails } = this.props.viewTicketState;
    const title = (
      <div className={`${styles.ticketTitle}`}>
        <b>
          {" "}
          {ticketDetails.data && ticketDetails.data.title
            ? ticketDetails.data.title
            : ""}
        </b>
      </div>
    );

    if (
      this.state.viewRenderMetadata !== [] &&
      this.state.viewRenderMetadata.title &&
      this.state.viewRenderMetadata.title !== renderOptions.HIDDEN
    ) {
      if (
        this.state.viewRenderMetadata.ewaybillValidityCheck !==
        renderOptions.HIDDEN
      ) {
        // A closed ticket has nothing left to check, so the button is shown only on open tickets.
        if (
          ticketDetails.data &&
          ticketDetails.data.ticketTypeDTO &&
          !this.isTicketClosed()
        ) {
          if (validityDetails.isLoading) {
            return (
              <div className={styles.titleBox}>
                <div className={styles.qcBtnWrapper}>Loading...</div>
                {title}
              </div>
            );
          }
          return (
            <div className={styles.titleBox}>
              <div
                className={styles.qcBtnWrapper}
                onClick={() => this.props.checkValidity(ticketDetails.data.id)}
              >
                Check Validity
              </div>
              {title}
            </div>
          );
        }
      }
      return <div className={styles.titleBox}>{title}</div>;
    }
    return null;
  }

  render() {
    const { ticketDetails, commentDetails } = this.props.viewTicketState;
    return (
      <div>
        {ticketDetails.isLoading ? <Loader /> : null}
        {this.state.showEscalateModal ? this.renderEscalateModal() : null}
        {this.state.showAttachmentModal ? this.renderAttachmentModal() : null}
        {this.state.showReasonForClosureModal
          ? this.renderReasonForClosureModal()
          : null}
        {this.state.showViewChildTicketModal
          ? this.renderViewChildTicketModal()
          : null}
        <div className={`${styles.ticketDetailWrapper}`}>
          <div className={styles.ticketDetailContainer}>
            <div className={`${this.returnUtilityStyle()} l-row a-center`}>
              <div className={`${styles.underline} flex-100 l-row`}>
                <h2> Ticket Details</h2>
              </div>
            </div>
            {this.renderTicketId(ticketDetails)}
            {this.renderTicketType(ticketDetails)}
            {this.renderPRQorCN(ticketDetails)}
            {this.renderSLA(ticketDetails)}
            {this.renderFirstResponseSLA(ticketDetails)}
            {this.renderOwner(ticketDetails)}
            {this.renderCCedEmailId()}
            {this.renderParentTicketId(ticketDetails)}
            {this.renderInteractionCount(ticketDetails)}
            {this.renderTicketStatus()}
            {this.renderTicketSeverity(ticketDetails)}
            {this.renderTicketAssignee()}
            <div className="l-row">
              <div className="flex-50">{this.renderAssist(ticketDetails)}</div>
              <div className="flex-45">
                {this.renderAssignToMe(ticketDetails)}
              </div>
            </div>
            <div className={`${this.returnUtilityStyle()} l-row a-center`}>
              {this.renderEscalateButton()}
              {this.renderCreateChildTicketButton(ticketDetails)}
            </div>
            <div className={`${this.returnUtilityStyle()} l-row a-center`}>
              {this.renderViewChildTicketButton()}
            </div>
            {this.checkRequestorTitleCondition() ? (
              <div className={`${this.returnUtilityStyle()} l-row a-center`}>
                <div className={`${styles.underline} flex-100 l-row`}>
                  <h2> Requestor Details</h2>
                </div>
              </div>
            ) : null}
            {this.renderRequestorName(ticketDetails)}
            {this.renderRequestorEmail(ticketDetails)}
            {this.renderRequestorMobile(ticketDetails)}
          </div>
        </div>
        <div
          className={
            this.isTicketClosed()
              ? styles.commentWrapperTicketClosed
              : styles.commentDetailWrapper
          }
        >
          <div className={styles.commentDetailContainer}>
            {this.renderButtonsBasedOnTicketType()}
            {this.renderTicketTitle(ticketDetails)}
            {this.renderTicketOwnerName(ticketDetails)}
            <div className={styles.allEvents}>Comments</div>
            {this.renderTicketComments(commentDetails)}
            {this.renderFooter()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  viewTicketState: state.viewTicketState,
  userProfile: state.userProfile,
  createTicketState: state.createTicketState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getTicketDetails: bindActionCreators(getTicketDetails, dispatch),
  sendCommentsDetails: bindActionCreators(sendCommentsDetails, dispatch),
  getCommentDetails: bindActionCreators(getCommentDetails, dispatch),
  getAssignToOptions: bindActionCreators(getAssignToOptions, dispatch),
  putEditTicketChanges: bindActionCreators(putEditTicketChanges, dispatch),
  putTicketEscalateEmail: bindActionCreators(putTicketEscalateEmail, dispatch),
  checkValidity: bindActionCreators(checkValidity, dispatch),
  getCcDetails: bindActionCreators(getCcDetails, dispatch),
  performTicketAction: bindActionCreators(performTicketAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTicket);



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/viewTicket/viewTicket.js